import React from 'react';
import Features from '../components/Home/Features';
import Hero from '../components/Home/Hero';
import Team from '../components/Home/Team';
import Cite from "../components/Home/Cite";

const Home = () => {
	return (
		<>
			<Hero />
			<Features />
			{/*<Team />*/}
			<Cite />
		</>
	)
}

export default Home